import { createFileRoute } from '@tanstack/react-router';
import { Layout } from '@/pages/layout';

export const Route = createFileRoute('/protected/_layout')({
  component: Layout,
});
